import React, { useEffect, useRef } from 'react';
import { TimelineLite, Power4 } from 'gsap';
import { navigate } from 'gatsby';
import { AppearText, AppearImage, } from '../common/appear'
import {
    ContainerWrapper,
    TagButton,
    Text,
} from './elements';

import User from './user';

import SVG1 from './1.svg';
import SVG2 from './2.svg';
import SVG3 from './3.svg';
import SVGBOOK from './book.svg';

const TITLE_DEFAULT = 'Personal';
const SUBTITLE_DEFAULT = 'Insurance Products';

const TagButtonFC = ({
        image = 1,
        normalText = SUBTITLE_DEFAULT,
        boldText = TITLE_DEFAULT,
        left = false,
        right = false,
        link = '/',
        large = false,
        full = false,
        onClickHandler = (event) => {
            event.preventDefault();
            // Event transition
            if (typeof window !== 'undefined' && window.scrollLib) {
                const ev = new Event('start-transition');
                window.dispatchEvent(ev);
                window.scrollLib.scrollTo(0);
            }
            setTimeout(() => {
                navigate(link);
            }, 1000);
        },
        icon = false
    }) => {

    const containerRef = useRef();

    const handleMouseOver = () => {
        if (typeof window !== 'undefined' && window.innerWidth < 600 ) return false;
        const tl = new TimelineLite({ paused: true });
        tl
            .to(containerRef.current, 1, {
                backgroundColor: '#0064BA',
                ease: Power4.easeInOut,
            })
            .to(containerRef.current, 0.5, {
                width: window.innerWidth < 1200 ? '95%' : '110%',
                ease: Power4.easeInOut,
            }, '-=1');
        tl.play();
    }
    const handleMouseLeave = () => {
        if (typeof window !== 'undefined' && window.innerWidth < 600) return false;
        const originalWidth = typeof window !== 'undefined' && window.innerWidth < 1200 ? 81 : 118;
        const tl = new TimelineLite({ paused: true });
        tl
            .to(containerRef.current, 0.5, {
                width: originalWidth,
                ease: Power4.easeInOut,
            })
            .to(containerRef.current, 1, {
                backgroundColor: '#6FB7FF',
                ease: Power4.easeInOut,
            }, '-=0.5');
        tl.play();
    }
    let imageOutput = SVG2;
    switch(image) {
        case 1:
            imageOutput = SVG1;
            break;
        case 2:
            imageOutput = SVG2;
            break;
        case 3:
            imageOutput = SVGBOOK;
            break;
        default:
            imageOutput = SVG3;
    }

    if ( icon ) {
        imageOutput = icon.publicURL;
    }

    return (
        <TagButton
            onMouseEnter={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            left={left}
            right={right}
            onClick={onClickHandler}
            large={large}
            full={full}
        >
            <ContainerWrapper ref={containerRef} className="circle">
                
                <AppearImage>
                    <User icon={imageOutput} />
                </AppearImage>
                <Text className="text" white large={large} full={full}>
                    <AppearText>
                        <strong>{boldText}</strong>
                        {
                            !full ? <><br />
                                        <span>
                                        {normalText}
                                        </span>
                                    </> : <noscript />
                        }
                    </AppearText>
                </Text>
            </ContainerWrapper>
            <Text className="text" large={large} full={full}>
                <AppearText>
                    <strong>{boldText}</strong>
                    <>
                        <br />
                        <span>
                            {normalText}
                        </span>
                    </>
                </AppearText>
            </Text>
        </TagButton>
    );
};
export default TagButtonFC;
